










import { Component, Mixins, Prop } from "vue-property-decorator";
import { ScaleDropDownSelector } from "../../../../drawing";
import { MenuPane } from "../../../../panes";
import { ModelEditableMixin } from "../../../../system/mixins";
import { DocumentEditInformationEditableMixin } from "../../mixins";

@Component({
  components: {
    MenuPane,
    ScaleDropDownSelector,
  }
})
export default class EditScaleSelector extends Mixins(ModelEditableMixin, DocumentEditInformationEditableMixin) {
  @Prop({ default: false })
  isHorizontal: boolean;

  get isDocumentAlreadyInitialized(): boolean {
    return this.isSourceEnable
      && this.editingSource.isAlreadyInitialized;
  }
}
